// Comprime/redimensiona fotos antes de guarda-las como base64, mantendo
// qualidade suficiente como evidencia visual, mas evitando o peso real de
// fotos de camera de celular (que podem chegar a varios MB cada). Reduz o
// tamanho final tipicamente em 10-20x, sem depender de nenhum servico
// externo -- tudo roda no proprio navegador, via canvas.
export function compressImageFile(file, { maxDim = 1600, quality = 0.75 } = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          if (width > height) {
            height = Math.round((height * maxDim) / width);
            width = maxDim;
          } else {
            width = Math.round((width * maxDim) / height);
            height = maxDim;
          }
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = () => reject(new Error("Falha ao carregar imagem para compressao"));
      img.src = reader.result;
    };
    reader.onerror = () => reject(new Error("Falha ao ler arquivo de imagem"));
    reader.readAsDataURL(file);
  });
}
